<div>
	<app-container title="Address & type" [testHook]="testHooks.Container">
		<app-jurisdiction-field></app-jurisdiction-field>

		<app-matter-address
			id="intercom-matter-address-field"
			class="mt-2"
		></app-matter-address>

		<div>
			<app-container
				type="dark"
				class="mt-10"
				[padding]="false"
				[testHook]="testHooks.Container1"
			>
				<div class="flex justify-between items-center p-3">
					<h4>Registration method</h4>
					<app-radio-group
						[items]="registrationItems"
						[ngModel]="selectedRegistrationMethod"
						(ngModelChange)="selectRegistrationMethod($event)"
						[testHook]="testHooks.SelectedRegistrationMethodRadioGroup"
					></app-radio-group>
				</div>
			</app-container>
		</div>

		<div>
			<app-container
				title="Property details"
				class="mt-10"
				type="dark"
				[testHook]="testHooks.PropertyDetailsContainer"
			>
				<app-property-type [showCondoPlanOverview]="false"></app-property-type>
			</app-container>
		</div>

		<app-container
			type="dark"
			title="Additional details"
			class="mt-10"
			[testHook]="testHooks.AdditionalDetailsContainer"
		>
			<div class="grid grid-cols-2 gap-2 mb-2">
				<app-interest-estate class="col-span-2"></app-interest-estate>

				<app-input
					class="col-span-1"
					label="Roll number"
					[ngModel]="rollNumber"
					(debounce)="setRollNumber($event)"
					[testHook]="testHooks.RollNumber"
					maxlength="21"
				></app-input>

				<app-date-picker
					class="col-span-1"
					label="Next Installment Due"
					[ngModel]="nextInstallmentDate"
					(ngModelChange)="setNextInstallmentDate($event)"
					[testHook]="testHooks.NextInstallmentDueDatePicker"
				></app-date-picker>

				<app-input
					class="col-span-2"
					label="Builder number"
					[ngModel]="builderNumber"
					(debounce)="setBuilderNumber($event)"
					*ngIf="propertyType?.status === propertyStatus.NEW"
					[@fade]
					[testHook]="testHooks.BuilderNumber"
				></app-input>

				<app-date-picker
					class="col-start-1"
					label="Survey date"
					[ngModel]="surveyDate"
					(ngModelChange)="setSurveyDate($event)"
					[testHook]="testHooks.SurveyDateDatePicker"
				></app-date-picker>
				<app-input
					class="col-start-2"
					label="Surveyor name"
					[ngModel]="surveyorName"
					(debounce)="setSurveyorName($event)"
					[testHook]="testHooks.SurveyorName"
				></app-input>
			</div>
		</app-container>
	</app-container>
</div>

<div>
	<h4 class="mb-4">Legal description</h4>
	<div
		class="py-4 px-4 rounded-xl w-full bg-grey-lightest flex justify-between mb-4"
		*ngIf="!matterTitles.length"
	>
		<p>
			{{
				parentPins.length > 0
					? 'Details from title search not synced'
					: 'Title search not yet completed'
			}}
		</p>

		<app-anchor
			type="static"
			(click)="goToTeranetSearch()"
			[testHook]="testHooks.Link"
			>{{ parentPins.length > 0 ? 'Sync details' : 'Start Teranet search' }}
		</app-anchor>
	</div>
	<app-container type="dark" [testHook]="testHooks.Container2">
		<ng-container>
			<div class="flex items-center">
				<h4 class="mb-0">
					{{
						propertyType?.type === propertyTypes.CONDO
							? 'Condo units'
							: 'Parcels'
					}}
				</h4>
				<app-button
					size="small"
					[icon]="ICON.ADD"
					class="ml-4"
					(click)="addTitle()"
					[testHook]="testHooks.AddTitleButton"
					>Add
					{{
						propertyType?.type === propertyTypes.CONDO ? 'unit' : 'parcel'
					}}</app-button
				>
			</div>
			<div
				*ngFor="let title of matterTitles | sort: ['primary'] : ['desc']"
				class="mt-2"
			>
				<app-property-unit-overview
					[title]="title"
				></app-property-unit-overview>
			</div>
		</ng-container>

		<app-parcel-of-tied-land-overview
			*ngIf="propertyType?.parcelOfTiedLand && propertyType?.condoPlan"
			class="mt-4"
			[testHook]="testHooks.ParcelOfTiedLandOverview"
		></app-parcel-of-tied-land-overview>

		<div
			class="p-2 rounded-xl flex justify-between bg-grey-lightest border-grey-lighter border mt-4"
			*ngIf="
				matterTitles.length > 0 &&
				(propertyType?.type === propertyTypes.CONDO ||
					propertyType?.parcelOfTiedLand)
			"
		>
			<span class="font-bold text-lg">Total common expenses</span>
			<span class="font-bold text-lg">{{
				commonExpensesTotal | centsToDollars
			}}</span>
		</div>
	</app-container>

	<ng-container *ngIf="showLtvSection$ | async">
		<app-container
			class="my-6 value-and-ltv-intercom-bot"
			[testHook]="testHooks.Container3"
		>
			<app-value-and-ltv></app-value-and-ltv>
		</app-container>
	</ng-container>
</div>
